import { render, staticRenderFns } from "./MessageAddView.vue?vue&type=template&id=282027c4&scoped=true&"
import script from "./MessageAddView.vue?vue&type=script&lang=js&"
export * from "./MessageAddView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=282027c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282027c4",
  null
  
)

export default component.exports